import clc from "cli-color";
import { format, transports, createLogger as winstonCreateLogger } from "winston";

const productionLoggerConfig = {
  level: "debug",
  format: format.combine(format.timestamp(), format.uncolorize(), format.metadata(), format.json()),
};

const devTransports = [
  new transports.Console({
    level: "silly",
    format: format.combine(
      format.timestamp({
        format: "HH:mm:ss:SSS",
      }),
      format.metadata(),
      format.printf(
        ({ level, message, metadata: { timestamp, listingId, scope, job, ...rest } }) => {
          const queueDetails = scope ? clc.magenta(` [${scope}]`) : "";
          const listingDetails = listingId ? clc.cyan(` [listing.id: ${listingId}]`) : "";
          const formattedRest =
            Object.keys(rest)?.length > 0 ? `\n${JSON.stringify(rest || {}, null, 2)}` : "";
          const paddedLevel = level.padEnd(5, " ");

          const colorByLevel = {
            error: clc.redBright,
            warn: clc.yellowBright,
            info: clc.greenBright,
            debug: clc.blueBright,
            silly: clc.magentaBright,
          };

          // @ts-expect-error any
          const formattedLevel = colorByLevel?.[level]?.(paddedLevel);

          const msg = `${timestamp} ${formattedLevel}${queueDetails}${listingDetails}: ${message}${formattedRest}`;

          if (job) {
            void job?.log?.(msg);
          }

          return msg;
        },
      ),
    ),
  }),
];

const prodTransports = [
  new transports.Console({
    ...productionLoggerConfig,
  }),
];

export const logger = winstonCreateLogger({
  transports: [...(process.env.NODE_ENV === "development" ? devTransports : prodTransports)],
});

export type LoggerMetadata = {
  scope: string | undefined;
  jobId?: string | number | undefined;
  listingId?: string | number | undefined;
};

export const createLogger = (meta: LoggerMetadata) => {
  return logger.child(meta);
};
